export default __webpack_public_path__ + "static/media/checkinmunchen.cfd504a9.svg";